import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {DateTime} from 'luxon';
import {switchMap, take} from 'rxjs/operators';

import {getDailyReservationsResource, StoreState} from '@redux/reducers';
import {SharedFacadeService} from '@shared/shared-facade.service';
import {ResourceService} from '@services/resource.service';

import {Resource, ResourceReservation} from '@model/resource';
import {Schedule} from '@model/schedule';
import {School} from '@model/school';
import {StaffMember} from '@model/staffMember';
import {schoolResourceDailyReservationsDeleted, schoolResourceDailyReservationsLoaded, schoolResourceDailyReservationsSaved} from '@redux/actions/resources.action';

@Injectable()
export class ResourcesFacadeService {
  school$: Observable<School>;
  isMobile$: Observable<boolean>;
  schedule$: Observable<Schedule>;
  resources$: Observable<Resource[]>;
  staffMembers$: Observable<StaffMember[]>;
  resourcesDailyReservations$: Observable<ResourceReservation[]>;

  constructor(private _store: Store<StoreState>,
    private _sharedFacade: SharedFacadeService,
    private _resourceService: ResourceService,
    ) {
    this.school$ = this._sharedFacade.school$;
    this.isMobile$ = this._sharedFacade.isMobile$;
    this.schedule$ = this._sharedFacade.schedule$;
    this.resources$ = this._sharedFacade.resources$;
    this.staffMembers$ = this._sharedFacade.staffMembers$;
    this.resourcesDailyReservations$ = this._store.pipe(
      select(getDailyReservationsResource)
    );
  }

  loadSchedule() {
    this._sharedFacade.loadSchedule();
  }

  loadResources() {
    this._sharedFacade.loadResources();
  }

  loadStaffMembers() {
    this._sharedFacade.loadStaffMembers();
  }

  getResourcesReservationsForDay(date: DateTime) {
    this.school$.pipe(
      take(1),
      switchMap(school => this._resourceService.getSchoolResourceReservationsByDay(school.id, date))
    ).subscribe(reservations => this._store.dispatch(schoolResourceDailyReservationsLoaded({reservations})));
  }

  addResourcesReservationsForDay(reservation: ResourceReservation) {
    this.school$.pipe(
      take(1),
      switchMap(school => this._resourceService.addSchoolResourceReservation(school.id, reservation.resourceId, reservation.date, reservation.hour, reservation.staffMemberId))
    ).subscribe(() => this._store.dispatch(schoolResourceDailyReservationsSaved({reservation})));
  }

  removeResourcesReservationsForDay(reservation: ResourceReservation) {
    this.school$.pipe(
      take(1),
      switchMap(school => this._resourceService.deleteSchoolResourceReservation(school.id, reservation.resourceId, reservation.date, reservation.hour))
    ).subscribe(() => this._store.dispatch(schoolResourceDailyReservationsDeleted({reservation})));
  }
}
